/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */
"use strict";

module.exports = function(config, get, post) {
	return {
		list: list,
		ownData: own_data
	};

	function list(){
		return get("/v2/callgroups/list");
	}

	function own_data(){
		return get("/v2/callgroups/own/data");
	}
};
